import { el, mount, unmount } from 'redom';

import './index.scss';

let chatFrame = null;

class LiveChat {

  constructor(_, configuration) {

    this.onClose = configuration.onClose;
    this.outsideEventRegistration = null;
    this.spinner = el('div.spinner-container', [
      el('ht-spinner', { size: 'small' }),
      el('span.sub-text', '👏 Hey there! Connecting you with the Venturz team...')
    ]);

    this.messageHandler = this.messageHandler.bind(this);

    this.el = el('#live-chat-main', {
      class: 'loading',
    }, [
      this.spinner
    ]);
  }

  messageHandler(event) {

    if (event.origin !== 'https://venturz.co') return;

    if (event.data && event.data.source === 'LiveChat' && event.data.action === 'close') {
      this.onClose();
    }
  }

  onmount() {

    if (chatFrame === null) {
      chatFrame = el('iframe', {
        src: `https://venturz.co/live-chat?origin=${window.location.origin}&popup=true&time=${Date.now()}`,
        width: '100%',
        height: '100%'
      });
    }
    chatFrame.style.display = 'none';
    mount(this.el, chatFrame);
    setTimeout(function someTimeLater() {
      unmount(this.el, this.spinner);
      this.el.classList.remove('loading');
      chatFrame.style.display = 'block';
    }.bind(this), 5000);

    window.addEventListener('message', this.messageHandler);

  }

  onunmount() {

    window.removeEventListener('message', this.messageHandler);

  }

}

export default LiveChat;